import apiConfig from '../../../api-config';
import { postRequest, postRequestCreatePassword, postRequestEditPassword } from './api-requests';

export const Passwords = Object.freeze({
    create: (token, details) => postRequestCreatePassword(`${apiConfig.base_url}/web/user/activate`, token, details),
    edit: details => postRequestEditPassword(`${apiConfig.base_url}/web/user/forgotten_password`, details),
    change: details => postRequest(`${apiConfig.base_url}/web/user/password`, details)
});



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-passwords.js